import { Box, Typography, useTheme } from '@mui/material'
import { getTableTimestamp } from 'src/common/utils'

interface IProps {
  date: Date
  loalTimezone?: string
  localDateFontSize?: string
  utcDateFontSize?: string
  containerSx?: object
}

export const UtcAndLocalDatesCell = ({
  date,
  loalTimezone = 'UTC',
  localDateFontSize,
  utcDateFontSize,
  containerSx,
}: IProps) => {
  const theme = useTheme()

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        gap: '3px',
        ...containerSx,
      }}
    >
      <Typography fontSize={localDateFontSize ?? '11px'}>
        {getTableTimestamp({ date, timezone: loalTimezone })}
      </Typography>
      <Typography fontSize={utcDateFontSize ?? '10px'} sx={{ color: theme.palette.custom.grey2 }}>
        {`${getTableTimestamp({ date, timezone: 'UTC' })} UTC`}
      </Typography>
    </Box>
  )
}
